export default status => {
  if (status === 'ACTIVE') {
    return '#ececff';
  } if (status === 'DEACTIVATED') {
    return '#e2e2e2';
  } if (status === 'EXPIRED') {
    return '#ee6972';
  } if (status === 'DELETED') {
    return '#e2e2e2';
  } return '#e2e2e2';
};
